const url = '/discountAccounts';
const Provider = 'DiscountAccounts';
const dbModel = 'DiscountAccounts';

export { url, Provider, dbModel };
